<template>
  <div>
    <div v-for="(item, index) in routes" :key="index" class="card box-shadow-default" @click="goStep(item)">
      <div class="card-icon" :style="{ backgroundImage: item.meta.background }">
        <i class="icon iconfont" :class="item.meta.icon"></i>
      </div>
      <div class="card-desc">
        <p class="card-desc-title">{{ item.meta.label }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { subRoutes } from 'iebdc/router';
import { mapGetters } from 'vuex';
import applicantFinishService from '@/pages/iebdc/api/apply/applicant-finish';
import { localDataPermissionByareaCode } from '@iebdc/utils/local-data';
export default {
  name: 'card-item',
  computed: {
    ...mapGetters(['selectedBsdtCode']),
    // 获取当前路由的子路由
    routes() {
      let data = [];
      const permissionArrByareaCode = localDataPermissionByareaCode.get() || [];
      subRoutes.forEach((item) => {
        if (item.name === this.$route.name) {
          console.log(item.children, 'item.children');
          item.children.forEach((pitem) => {
            //房产信息查询功能添加区县权限判断
            // if (pitem.meta.permission === 'IEBDC:SY:XXCX:FCXXCX') {
            //   if (this.$hasPermission(pitem.meta.permission) && permissionArrByareaCode.includes(pitem.meta.permission)) {
            //     // 二级路由（无具体页面）
            //     data.push(pitem);
            //   }
            // } else {
            //   if (this.$hasPermission(pitem.meta.permission)) {
            //     // 二级路由（无具体页面）
            //     data.push(pitem);
            //   }
            // }

            if (this.$hasPermission(pitem.meta.permission)) {
              // 二级路由（无具体页面）
              data.push(pitem);
            }
          });
        }
      });

      return data;
    },
  },
  methods: {
    //跳转
    goStep(item) {
      if (item.meta.label === '公示公告') {
        this.getBsdtDetail(item.name);
      } else {
        this.$router.push({
          name: item.name,
        });
      }
    },
    //获取公示公告外链地址
    async getBsdtDetail(name) {
      const { success, data } = await applicantFinishService.getBsdtDetail({ officeCode: this.selectedBsdtCode });
      if (success && data.gsggurl) {
        //配置了公示公告外链则直接跳转
        window.open(data.gsggurl);
      } else {
        this.$router.push({
          name,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/pages/iebdc/styles/public';
@import 'src/pages/iebdc/styles/common-variables';
.card {
  transition: 0.3s all;
  float: left;
  background-color: #fff;
  border-radius: 5px;
  height: 130px;
  line-height: 131px;
  margin-bottom: 20px;
  cursor: pointer;
  width: calc(100% / 4 - 19px);
  margin-right: 25px;
  &:nth-child(4n) {
    margin-right: 0;
  }
  .card-icon {
    float: left;
    margin-top: 23px;
    text-align: center;
    width: 84px;
    height: 84px;
    line-height: 84px;
    border-radius: 100%;
    color: #ffffff;
    margin-left: 18px;
    .iconfont {
      font-size: 30px;
    }
  }
  .card-desc {
    display: inline-block;
    letter-spacing: 1px;
    text-align: center;
    width: calc(100% - 104px);
    font-size: 18px;
    .card-desc-title {
      font-weight: $--font-weight-primary;
      color: $--color-text-regular;
    }
  }
  &:hover {
    -webkit-transform: translateY(-3px);
    -ms-transform: translateY(-3px);
    transform: translateY(-3px);
    -webkit-box-shadow: 0 0 6px #999;
    box-shadow: 0 0 6px #999;
    -webkit-transition: all 0.5s ease-out;
    transition: all 0.5s ease-out;
    background-color: #2c8bff;
    .card-desc,
    .card-desc-title {
      color: #ffffff;
    }
    .card-icon {
      background: #ffffff !important;
      color: #2c8bff !important;
    }
  }
}
</style>
